import { Button, Modal, ModalActions, ModalContent, ModalHeader, } from '@lightspeed/design-system-react';
import { useT } from '@transifex/react';
import { trackUserEvent } from '@vend/utilities';
import React, { useCallback, useState } from 'react';
import { withTranslations } from '../../tx';
import { UBE_MODULE_COMPROMISED_PASSWORD } from './constants';
import { NewPassword } from './NewPassword';
const ChangeCompromisedPasswordModalUnconnected = ({ onNewPasswordChange, isSubmiting, onCancel, onSubmit, onClose, authType = 'signin', dismissable = true, }) => {
    const t = useT();
    // local copy of the new password for validation
    const [newPassword, setNewPassword] = useState('');
    const [hasClickedSubmit, sethasClickedSubmit] = useState(false);
    const onPasswordChange = useCallback((password, isValid) => {
        if (isValid) {
            onNewPasswordChange(password);
            setNewPassword(password);
            return;
        }
        setNewPassword('');
    }, [onNewPasswordChange]);
    const handleCancel = () => {
        // clear new password
        setNewPassword('');
        onNewPasswordChange('');
        onCancel();
    };
    const handleSubmit = async () => {
        sethasClickedSubmit(true);
        if (newPassword === '') {
            return;
        }
        trackUserEvent(UBE_MODULE_COMPROMISED_PASSWORD, 'Set New Password Clicked');
        onSubmit();
    };
    return (React.createElement(Modal, { focusTrapActive: true, size: "small", pageModal: authType === 'signin', onClose: onClose, dismissable: dismissable },
        React.createElement(ModalHeader, null,
            React.createElement("div", { className: "vd-flex vd-flex--align-center" },
                React.createElement("div", { className: "vd-text-heading" }, t('Change your password', {
                    _context: 'change compromised password modal -  header',
                })))),
        React.createElement(ModalContent, null,
            React.createElement("div", { className: "vd-field" },
                React.createElement("div", { className: "vd-value" },
                    React.createElement(NewPassword, { onPasswordChange: onPasswordChange, hasClickedSubmit: hasClickedSubmit })))),
        React.createElement(ModalActions, null,
            React.createElement(Button, { "data-track": "change-compromised-password-modal-cancel", className: "vd-mr2", variant: "supplementary", onClick: handleCancel }, t('Cancel', {
                _context: 'change compromised password modal - button',
            })),
            React.createElement(Button, { "data-track": "change-compromised-password-modal-save", variant: "go", type: "submit", loading: isSubmiting, onClick: handleSubmit }, t('Save new password', {
                _context: 'change compromised password modal - button',
            })))));
};
export const ChangeCompromisedPasswordModal = withTranslations(ChangeCompromisedPasswordModalUnconnected, 
// eslint-disable-next-line i18next/no-literal-string
'ChangeCompromisedPasswordModal');
